import { createFeature, createReducer, on } from '@ngrx/store';

import { registerUpdateAvailable } from 'app/state/service-worker/service-worker.actions';

export const serviceWorkerFeatureKey = 'serviceWorker';

export interface ServiceWorkerState {
    isUpdateAvailable: boolean;
}

export const initialState: ServiceWorkerState = {
    isUpdateAvailable: false,
};

export const reducer = createReducer(
    initialState,
    on(registerUpdateAvailable, (state) => ({ ...state, isUpdateAvailable: true })),
);

export const serviceWorkerFeature = createFeature({
    name: serviceWorkerFeatureKey,
    reducer,
});
